<div *ngIf="isScrollerButtonShown" class="btn" (click)="scrollTo()">
    <img src="assets/icons/chevron-down.svg" alt="" width="24" height="24" />
</div>
